// extracted by mini-css-extract-plugin
export default {"nodatafound":"technicalerror_nodatafound__E-Unm","errorpage":"technicalerror_errorpage__Y-MYP"};